module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-bg"
  }, [_c('div', {
    staticClass: "button-group"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": _vm.clickDefine
    }
  }, [_vm._v(_vm._s(_vm.loading ? '正在通信' : '确认'))])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b8f2a5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tempControl/Mconfirm.vue
// module id = 918
// module chunks = 1